import { SkusTypes } from './types'
import { Action } from '../types'
import { Sku } from '../../types/skus'

type SkuAction = Action<SkusTypes, Sku[]>

const initialState: Sku[] = []

export function skusReducer(
  state = initialState,
  action: SkuAction
): Sku[] {
  switch (action.type) {
    case SkusTypes.SAVE_SKUS:
      return action.payload
    default:
      return state
  }
}
